/* eslint-disable react/destructuring-assignment */
import React from 'react';
import Avatar from 'react-avatar';
import format from 'date-fns/format';
import OptionsItemSelection from './OptionsItemSelection';

export default function (
  t,
  lastListOfItems,
  onStateUpdate,
  selectedValue,
  showResponsiveField
) {
  const textEllipsis = {
    maxWidth: '10rem',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  };
  const actions = [
    {
      title: t('general.tables.photo'),
      render: (rowData) => (
        <Avatar
          size="40"
          round="20px"
          src={rowData.student.profilePhotoUrl}
          name={rowData.student.fullName}
        />
      ),
    },

    { title: t('general.student'), field: 'student.fullName' },
    { title: t('general.item'), field: 'item' },
    {
      title: t('general.option'),
      render: (rowData) => (
        <OptionsItemSelection
          items={lastListOfItems}
          selectedItem={selectedValue}
          handleChange={(value, typeOfMeal, valueNote) => {
            const newData = {
              ...rowData,
              id: 0,
              idResponsible: 0,
              idItemNote: value,
              typeOfMeal,
              valueNote,
            };
            onStateUpdate(rowData, newData);
          }}
        />
      ),
    },

    {
      title: t('general.date'),
      field: 'dateNote',
      render: (rowData) =>
        rowData.dateNote
          ? format(new Date(rowData.dateNote), 'dd/MM/yyyy')
          : null,
    },
    { title: t('general.hour'), field: 'hourNote' },
    {
      title: t('mnt_appointment.adjunct'),
      field: 'noteComplement',
      cellStyle: textEllipsis,
      render: (rowData) => (
        <span className="tooltip-test" title={rowData.noteComplement}>
          {rowData.noteComplement}
        </span>
      ),
    },
  ];
  if (showResponsiveField) {
    actions.splice(6, 0, {
      title: t('general.responsible-account'),
      field: 'responsible.label',
    });
  }
  return actions;
}
